module.exports = __webpack_public_path__ + "next1.png?274987279d709f7a607206ef8e738f88";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next1.png
// module id = 65
// module chunks = 0